import { Link } from "react-router-dom";
import MovieCard from "@/components/feature/MovieCard";
import { getLatestMovies } from "@/lib/movie";

export default function LatestSection() {
  const latest = getLatestMovies(8);

  return (
    <section className="w-full border-y border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="font-label text-[11px] uppercase tracking-[0.24em] text-primary-600">
              Just Updated
            </p>
            <h2 className="mt-2 text-xl font-bold text-foreground-950 md:text-2xl">最新上映</h2>
            <p className="mt-2 max-w-xl text-sm leading-relaxed text-foreground-600">
              按更新时间排序的最新片单，封面、年份与详情页信息一一对应。
            </p>
          </div>
          <Link
            to="/category?sort=updated"
            className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700"
          >
            查看全部影片
            <i className="ri-arrow-right-line text-sm w-4 h-4 flex items-center justify-center" />
          </Link>
        </div>

        <div className="mt-7 grid grid-cols-2 gap-x-4 gap-y-7 sm:grid-cols-3 lg:grid-cols-4">
          {latest.map((movie, index) => (
            <MovieCard key={movie.id} movie={movie} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
}